import { render, staticRenderFns } from "./CustomAddressf.vue?vue&type=template&id=0d49cda6&"
import script from "./CustomAddressf.vue?vue&type=script&lang=js&"
export * from "./CustomAddressf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapAddress: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/Map/Address.vue').default})
